export default __webpack_public_path__ + "static/media/(17).0fc94e35.jpeg";